// extracted by mini-css-extract-plugin
export default {"nav-category":"NavCategory_nav-category__8FH40","subnav-category":"NavCategory_subnav-category__hTqYD"};